import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';
import { RoleVO } from '../../admin-profile/models/resource';
import { ApplicationProfilesVO } from '../../admin-profile/models/applicationProfile';
import { ApplicationVO } from './application';
import { PayrollHrManagersRequest, PayrollHrManagersVO } from 'mds-ui/app/modules/hr/models/payrollHrManager';
import { RoleDTO } from '../../psms-users/models/psmsuser.model';



export class UserVO{
    firstName: string;
    emailId: string;
    lastName: string;
    profileName: string;
    roleName: string;
    applicationProfilesVO: ApplicationProfilesVO;
    userRoleVO: UserRoleVO;
    userRoleProfileXrefVO: UserRoleProfileXrefVO;
    resourceVOList:userResourceVO[];
    userApplicationVOList: ApplicationVO[];
    personId: number = 0;
    personName: string = '';
    payrollHrManagersRequest: PayrollHrManagersRequest;
    payrollHrManagersVOList: PayrollHrManagersVO[]
    roles: RoleDTO
}



export class UserRoleProfileXrefVO{
     id:number;
     firstName: string;
     lastName: string;
     appLoginEmail:string;
     applicationId:number;
     roleId:number;
     profileId:number;
     isActive: string;
     createdBy: string;
     createdTime: Date;
     lastUpdatedBy: string;
     lastUpdatedTime: Date;
     application:ApplicationVO;
     role:RoleVO;
     applicationProfiles:ApplicationProfilesVO;
}

export class UserResponse{
    apiResponseVO: ApiResponse;
    userVOList: UserVO[];
}
  

export class userResourceVO{
    resourceId: number;
    name: string;
    application: ApplicationVO;
    applicationId: number;
    type: string;
    category: string;
    parentId: number;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
    permissions: PermissionResourceVO[]
} 
export class PermissionResourceVO{
    permissionId: number;
    permissionName: string;
    resourceId: number;
    name: string;
    applicationId: number;
    type: string;
}
export class UserApplicationVO{
   
    applicationId: number;
    displayName:string
    name: string;
    isActive: string;
} 
export class UserRoleVO{
    id: number;
    name: string;
    applicationId: number;
    description: string;
    isActive: string;
    userAssociateTypeVOList: UserAssociateTypeVO; 
    participantVOList:UserParticipantVO[];  
}

export class UserAssociateTypeVO{
    id: number;
    associateType: string;
}
  
export class UserParticipantVO{
    id: number;
    name: string;
    serenicId: number;
    ori: string;
    oca: string;
    mailCode: string;
    ministryType: string;
    type: string;
    isActive: string;
}
 